export type SyncStatusFlag =
  | "SYNCED"
  | "DIRTY"
  | "OUT_OF_DATE"
  | "CONFLICTING"
  | "CHANGE_REQUEST_PENDING"
  | "INTEGRATION_BLOCKED"
  | "DIVERGED";

type PublishMode = "noop" | "direct_push" | "pull_request";

/**
 * Direct pushes can briefly report OUT_OF_DATE until remote-head checks catch up.
 * Hide that transient flag while preserving all other status signals.
 */
export const derivePostCommitUiFlags = ({
  flags,
  publishMode,
  commitSha,
}: {
  flags: SyncStatusFlag[];
  publishMode: PublishMode;
  commitSha?: string;
}): SyncStatusFlag[] => {
  const shouldSuppressOutOfDate =
    publishMode === "direct_push" &&
    typeof commitSha === "string" &&
    commitSha.length > 0 &&
    flags.includes("OUT_OF_DATE") &&
    !flags.includes("DIRTY") &&
    !flags.includes("CONFLICTING") &&
    !flags.includes("DIVERGED");

  if (!shouldSuppressOutOfDate) return flags;

  const nextFlags = flags.filter((flag) => flag !== "OUT_OF_DATE");
  if (nextFlags.length === 0) {
    return ["SYNCED"];
  }
  return nextFlags;
};
